import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';

const OnboardingIcon = (props) => {
    const {...other} = props;
    return (
        <AddLocationAltIcon {...other}/>
    )
}

export default OnboardingIcon;